(() => {
  const initializeProductSection = (root) => {
    if (!root || root.dataset.twomatoesProductInitialized === 'true') return;
    root.dataset.twomatoesProductInitialized = 'true';

    // Product video thumbnails use the shared Metaobject gallery, with per-product override.
    // Clone only the active <template> into the modal: offscreen stories never load videos.
    const storyTrack = root.querySelector('[data-product-stories-track]');
    const storyDialog = root.querySelector('[data-product-stories-dialog]');
    const storyPlayer = storyDialog?.querySelector('[data-product-stories-player]');
    const storyPlayButton = storyDialog?.querySelector('[data-product-stories-play]');
    const storySoundButton = storyDialog?.querySelector('[data-product-stories-sound]');
    const storyPrevButton = storyDialog?.querySelector('[data-product-stories-prev]');
    const storyNextButton = storyDialog?.querySelector('[data-product-stories-next]');
    const storyProgress = storyDialog?.querySelector('[data-product-stories-progress]');
    const storyAddButton = storyDialog?.querySelector('[data-product-stories-add]');
    const storyTriggers = Array.from(storyTrack?.querySelectorAll('[data-product-stories-open]') || []);
    let activeStoryVideo = null;
    let activeStoryIndex = -1;
    let mutedStories = true;
    let lastStoryTrigger = null;

    if (storyTrack && storyDialog && storyPlayer && storyTriggers.length && typeof storyDialog.showModal === 'function') {
      const updateStoryProgress = () => {
        const ratio = activeStoryVideo && Number.isFinite(activeStoryVideo.duration) && activeStoryVideo.duration > 0 ? Math.min(1, activeStoryVideo.currentTime / activeStoryVideo.duration) : 0;
        if (storyProgress) storyProgress.style.transform = `scaleX(${ratio})`;
      };

      const syncStoryControls = () => {
        const playing = Boolean(activeStoryVideo && !activeStoryVideo.paused && !activeStoryVideo.ended);
        storyPlayButton?.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        storyPlayButton?.setAttribute('aria-pressed', String(playing));
        storyPlayButton?.classList.toggle('is-playing', playing);
        storySoundButton?.setAttribute('aria-label', mutedStories ? 'Turn sound on' : 'Mute video');
        storySoundButton?.setAttribute('aria-pressed', String(!mutedStories));
        storySoundButton?.classList.toggle('is-unmuted', !mutedStories);
      };

      const stopStoryVideo = () => {
        if (activeStoryVideo) {
          activeStoryVideo.pause();
          activeStoryVideo.removeAttribute('src');
          activeStoryVideo.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          activeStoryVideo.load();
        }
        activeStoryVideo = null;
        storyPlayer.replaceChildren();
        if (storyProgress) storyProgress.style.transform = 'scaleX(0)';
      };

      const syncStoryProduct = () => {
        const price = root.querySelector('[data-product-heading-price]');
        const compare = root.querySelector('[data-product-heading-compare-price]');
        const discount = root.querySelector('[data-product-heading-discount]');
        const purchaseButton = root.querySelector('[data-add-to-cart]');
        const modalPrice = storyDialog.querySelector('[data-product-stories-price]');
        const modalCompare = storyDialog.querySelector('[data-product-stories-compare]');
        const modalDiscount = storyDialog.querySelector('[data-product-stories-discount]');
        if (modalPrice && price) modalPrice.textContent = price.textContent;
        if (modalCompare && compare) { modalCompare.textContent = compare.textContent; modalCompare.hidden = compare.hidden; }
        if (modalDiscount && discount) { modalDiscount.textContent = discount.textContent; modalDiscount.hidden = discount.hidden; }
        if (storyAddButton && purchaseButton) storyAddButton.disabled = purchaseButton.disabled;
      };

      const showStory = (index) => {
        if (index < 0 || index >= storyTriggers.length) return;
        const trigger = storyTriggers[index];
        const template = trigger.parentElement?.querySelector('[data-product-stories-template]');
        if (!template?.content.querySelector('video')) return;
        if (!storyDialog.open) {
          lastStoryTrigger = trigger;
          storyDialog.showModal();
        }
        stopStoryVideo();
        activeStoryIndex = index;
        storyPlayer.appendChild(template.content.cloneNode(true));
        activeStoryVideo = storyPlayer.querySelector('video');
        if (!activeStoryVideo) return;
        activeStoryVideo.controls = false;
        activeStoryVideo.muted = mutedStories;
        activeStoryVideo.playsInline = true;
        activeStoryVideo.autoplay = false;
        activeStoryVideo.loop = false;
        activeStoryVideo.addEventListener('play', syncStoryControls);
        activeStoryVideo.addEventListener('pause', syncStoryControls);
        activeStoryVideo.addEventListener('ended', syncStoryControls);
        activeStoryVideo.addEventListener('volumechange', syncStoryControls);
        activeStoryVideo.addEventListener('timeupdate', updateStoryProgress);
        activeStoryVideo.addEventListener('loadedmetadata', updateStoryProgress);
        activeStoryVideo.addEventListener('click', toggleStoryPlayback);
        storyPrevButton.disabled = index === 0;
        storyNextButton.disabled = index === storyTriggers.length - 1;
        storyPrevButton.hidden = storyTriggers.length < 2;
        storyNextButton.hidden = storyTriggers.length < 2;
        syncStoryProduct();
        syncStoryControls();
        const playback = activeStoryVideo.play();
        if (playback?.catch) playback.catch(syncStoryControls);
      };

      function toggleStoryPlayback() {
        if (!activeStoryVideo) return;
        if (!activeStoryVideo.paused && !activeStoryVideo.ended) activeStoryVideo.pause();
        else {
          if (activeStoryVideo.ended) activeStoryVideo.currentTime = 0;
          const playback = activeStoryVideo.play();
          if (playback?.catch) playback.catch(syncStoryControls);
        }
      }

      const closeStory = () => { if (storyDialog.open) storyDialog.close(); };
      const unloadStory = () => {
        stopStoryVideo();
        activeStoryIndex = -1;
        if (lastStoryTrigger?.isConnected) lastStoryTrigger.focus({ preventScroll: true });
        lastStoryTrigger = null;
      };
      storyTriggers.forEach((trigger, index) => trigger.addEventListener('click', () => showStory(index)));
      storyPrevButton?.addEventListener('click', () => showStory(activeStoryIndex - 1));
      storyNextButton?.addEventListener('click', () => showStory(activeStoryIndex + 1));
      storyPlayButton?.addEventListener('click', toggleStoryPlayback);
      storySoundButton?.addEventListener('click', () => {
        mutedStories = !mutedStories;
        if (activeStoryVideo) activeStoryVideo.muted = mutedStories;
        syncStoryControls();
      });
      storyAddButton?.addEventListener('click', () => {
        const purchaseButton = root.querySelector('[data-add-to-cart]');
        if (!purchaseButton || purchaseButton.disabled) return;
        closeStory();
        purchaseButton.click();
      });
      storyDialog.querySelector('[data-product-stories-close]')?.addEventListener('click', closeStory);
      storyDialog.addEventListener('click', (event) => { if (event.target === storyDialog) closeStory(); });
      storyDialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' && activeStoryIndex > 0) { event.preventDefault(); showStory(activeStoryIndex - 1); }
        if (event.key === 'ArrowRight' && activeStoryIndex < storyTriggers.length - 1) { event.preventDefault(); showStory(activeStoryIndex + 1); }
      });
      storyDialog.addEventListener('close', unloadStory);
      root.twomatoesProductStoryCleanup = () => { closeStory(); unloadStory(); };
    }

    const viewersWidget = root.querySelector('[data-product-viewers]');
    const viewersCount = root.querySelector('[data-product-viewers-count]');
    const viewersLabel = root.querySelector('[data-product-viewers-label]');

    if (viewersWidget && viewersCount && viewersLabel) {
      let randomValue = 0;

      if (window.crypto?.getRandomValues) {
        const randomArray = new Uint32Array(1);
        window.crypto.getRandomValues(randomArray);
        randomValue = randomArray[0] / 4294967296;
      } else {
        randomValue = Math.random();
      }

      const count = 7 + Math.floor(randomValue * 8);
      viewersCount.textContent = String(count);
      viewersLabel.textContent = count === 1 ? 'person viewing' : 'people viewing';
      viewersWidget.setAttribute('aria-label', `${count} ${count === 1 ? 'person is' : 'people are'} currently viewing this product`);
      viewersWidget.classList.add('is-ready');
    }

    const descriptionWrap = root.querySelector('[data-product-description-wrap]');
    const description = root.querySelector('[data-product-description]');
    const descriptionToggle = root.querySelector('[data-product-description-toggle]');
    const descriptionToggleLabel = root.querySelector('[data-product-description-toggle-label]');

    if (descriptionWrap && description && descriptionToggle && descriptionToggleLabel) {
      const syncDescriptionToggle = () => {
        if (descriptionWrap.classList.contains('is-expanded')) return;

        descriptionToggle.hidden = true;
        window.requestAnimationFrame(() => {
          const isOverflowing = description.scrollHeight > description.clientHeight + 1;
          descriptionToggle.hidden = !isOverflowing;
        });
      };

      descriptionToggle.addEventListener('click', () => {
        const expanded = descriptionWrap.classList.toggle('is-expanded');
        descriptionToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        descriptionToggleLabel.textContent = expanded ? 'Read less' : 'Read more';

        if (!expanded) window.requestAnimationFrame(syncDescriptionToggle);
      });

      syncDescriptionToggle();
      root.twomatoesDescriptionResizeHandler = syncDescriptionToggle;
      window.addEventListener('resize', root.twomatoesDescriptionResizeHandler, { passive: true });
    }

    const gallery = root.querySelector('[data-product-gallery]');
    const track = root.querySelector('[data-product-gallery-track]');
    const slides = Array.from(root.querySelectorAll('[data-product-gallery-slide]'));
    const thumbnails = Array.from(root.querySelectorAll('[data-product-gallery-thumbnail]'));
    let previousButton = null;
    let nextButton = null;

    let currentSlideIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));
    if (currentSlideIndex < 0) currentSlideIndex = 0;

    const updateArrowState = () => {
      if (previousButton) previousButton.disabled = currentSlideIndex === 0;
      if (nextButton) nextButton.disabled = currentSlideIndex === slides.length - 1;
    };

    const setActiveThumbnail = (index) => {
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === index;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      updateArrowState();
    };

    const syncVideoPlayback = (activeIndex) => {
      slides.forEach((slide, slideIndex) => {
        slide.querySelectorAll('video').forEach((video) => {
          if (slideIndex === activeIndex) {
            video.muted = true;
            video.playsInline = true;
            const playPromise = video.play();
            if (playPromise?.catch) playPromise.catch(() => {});
            return;
          }

          if (!video.paused) video.pause();
        });
      });
    };

    const goToSlide = (index, animate = true) => {
      if (!track || slides.length === 0) return;

      currentSlideIndex = Math.max(0, Math.min(slides.length - 1, index));
      track.classList.toggle('is-dragging', !animate);
      track.style.transition = animate ? 'transform .5s ease' : 'none';
      track.style.transform = `translate3d(-${currentSlideIndex * 100}%, 0, 0)`;
      setActiveThumbnail(currentSlideIndex);
      syncVideoPlayback(currentSlideIndex);

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === currentSlideIndex);
        slide.setAttribute('aria-hidden', slideIndex === currentSlideIndex ? 'false' : 'true');
      });
    };

    const showMedia = (mediaId) => {
      if (!mediaId) return;
      const targetSlide = slides.find((slide) => slide.dataset.mediaId === String(mediaId));
      if (!targetSlide) return;

      const index = slides.indexOf(targetSlide);
      if (index >= 0) goToSlide(index);
    };

    if (gallery && track && slides.length > 1) {
      gallery.tabIndex = 0;
      gallery.setAttribute('role', 'region');
      gallery.setAttribute('aria-label', 'Product media gallery');

      const createGalleryArrow = (direction) => {
        const button = document.createElement('button');
        const isPrevious = direction === 'previous';

        button.type = 'button';
        button.className = `product-gallery-arrow ${isPrevious ? 'is-previous' : 'is-next'}`;
        button.setAttribute('aria-label', isPrevious ? 'Show previous product media' : 'Show next product media');
        button.innerHTML = isPrevious
          ? '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5L8 12L15 19" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
          : '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5L16 12L9 19" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

        gallery.appendChild(button);
        return button;
      };

      previousButton = gallery.querySelector('.product-gallery-arrow.is-previous') || createGalleryArrow('previous');
      nextButton = gallery.querySelector('.product-gallery-arrow.is-next') || createGalleryArrow('next');

      previousButton.addEventListener('click', () => goToSlide(currentSlideIndex - 1));
      nextButton.addEventListener('click', () => goToSlide(currentSlideIndex + 1));

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const index = Number.parseInt(thumbnail.dataset.slideIndex || '0', 10);
          goToSlide(index);
        });
      });

      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToSlide(currentSlideIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToSlide(currentSlideIndex + 1);
        }
      });

      let pointerId = null;
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      const finishDrag = () => {
        if (!isDragging) return;

        const distance = currentX - startX;
        const threshold = Math.min(80, Math.max(35, gallery.clientWidth * 0.1));

        track.classList.remove('is-dragging');

        if (distance <= -threshold) {
          goToSlide(currentSlideIndex + 1);
        } else if (distance >= threshold) {
          goToSlide(currentSlideIndex - 1);
        } else {
          goToSlide(currentSlideIndex);
        }

        isDragging = false;
        pointerId = null;
      };

      gallery.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('button, a, video, model-viewer, iframe')) return;

        pointerId = event.pointerId;
        startX = event.clientX;
        currentX = event.clientX;
        isDragging = true;

        gallery.setPointerCapture?.(pointerId);
        track.classList.add('is-dragging');
      });

      gallery.addEventListener('pointermove', (event) => {
        if (!isDragging || event.pointerId !== pointerId) return;

        currentX = event.clientX;
        const distance = currentX - startX;
        const baseOffset = currentSlideIndex * gallery.clientWidth;
        track.style.transform = `translate3d(${distance - baseOffset}px, 0, 0)`;
      });

      gallery.addEventListener('pointerup', (event) => {
        if (event.pointerId !== pointerId) return;
        finishDrag();
      });

      gallery.addEventListener('pointercancel', finishDrag);
      gallery.addEventListener('lostpointercapture', finishDrag);

      goToSlide(currentSlideIndex, false);
      window.requestAnimationFrame(() => {
        track.classList.remove('is-dragging');
        track.style.transition = 'transform .5s ease';
      });
    }

    const saleTimer = root.querySelector('[data-product-sale-timer]');
    const saleTimerBar = root.querySelector('[data-product-sale-timer-bar]');
    const saleTimerText = root.querySelector('[data-product-sale-timer-text]');
    const saleTimerCountdown = root.querySelector('[data-product-sale-timer-countdown]');
    const saleTimerConfigElements = Array.from(root.querySelectorAll('[data-product-sale-timer-config]'));
    const SALE_TIMER_TIME_ZONE = 'Europe/Vilnius';

    const parseTimerLocalDateTime = (value) => {
      const match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!match) return null;

      const parts = {
        year: Number(match[1]),
        month: Number(match[2]),
        day: Number(match[3]),
        hour: Number(match[4]),
        minute: Number(match[5]),
        second: Number(match[6] || 0)
      };

      if (
        parts.month < 1 || parts.month > 12 ||
        parts.day < 1 || parts.day > 31 ||
        parts.hour < 0 || parts.hour > 23 ||
        parts.minute < 0 || parts.minute > 59 ||
        parts.second < 0 || parts.second > 59
      ) return null;

      const validationDate = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second));
      if (
        validationDate.getUTCFullYear() !== parts.year ||
        validationDate.getUTCMonth() + 1 !== parts.month ||
        validationDate.getUTCDate() !== parts.day ||
        validationDate.getUTCHours() !== parts.hour ||
        validationDate.getUTCMinutes() !== parts.minute ||
        validationDate.getUTCSeconds() !== parts.second
      ) return null;

      return parts;
    };

    const saleTimerFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: SALE_TIMER_TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const getTimerZonedParts = (timestamp) => {
      const parts = saleTimerFormatter.formatToParts(new Date(timestamp));
      const values = {};

      parts.forEach((part) => {
        if (part.type !== 'literal') values[part.type] = Number(part.value);
      });

      return {
        year: values.year,
        month: values.month,
        day: values.day,
        hour: values.hour,
        minute: values.minute,
        second: values.second
      };
    };

    const timerLocalPartsToUtc = (parts) => {
      if (!parts) return Number.NaN;

      const desiredUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      let guess = desiredUtc;

      for (let index = 0; index < 4; index += 1) {
        const zoned = getTimerZonedParts(guess);
        const zonedAsUtc = Date.UTC(zoned.year, zoned.month - 1, zoned.day, zoned.hour, zoned.minute, zoned.second);
        const offset = zonedAsUtc - guess;
        const nextGuess = desiredUtc - offset;

        if (Math.abs(nextGuess - guess) < 1) return nextGuess;
        guess = nextGuess;
      }

      return guess;
    };

    const addTimerCalendarDays = (parts, days) => {
      const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + days, parts.hour, parts.minute, parts.second));

      return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate(),
        hour: date.getUTCHours(),
        minute: date.getUTCMinutes(),
        second: date.getUTCSeconds()
      };
    };

    const saleTimerConfigs = saleTimerConfigElements.map((element, order) => {
      const startParts = parseTimerLocalDateTime(element.dataset.startDatetime);
      const endParts = parseTimerLocalDateTime(element.dataset.endDatetime);
      const firstStart = timerLocalPartsToUtc(startParts);
      const firstEnd = timerLocalPartsToUtc(endParts);
      const repeatEveryDays = Math.max(1, Number.parseInt(element.dataset.repeatEveryDays || '7', 10) || 7);
      const repeatIndefinitely = element.dataset.repeatIndefinitely === 'true';
      const repeatCount = Math.max(1, Number.parseInt(element.dataset.repeatCount || '1', 10) || 1);

      return {
        id: element.dataset.timerId || String(order),
        order,
        text: element.dataset.timerText || '',
        backgroundColor: element.dataset.backgroundColor || '#422453',
        textColor: element.dataset.textColor || '#ffffff',
        startParts,
        endParts,
        firstStart,
        firstEnd,
        repeatEveryDays,
        repeatIndefinitely,
        repeatCount
      };
    }).filter((timer) => (
      timer.startParts &&
      timer.endParts &&
      Number.isFinite(timer.firstStart) &&
      Number.isFinite(timer.firstEnd) &&
      timer.firstEnd > timer.firstStart
    ));

    const getActiveTimerOccurrence = (timer, now) => {
      if (!timer || now < timer.firstStart) return null;

      const repeatApproxMs = timer.repeatEveryDays * 86400000;
      const durationMs = timer.firstEnd - timer.firstStart;
      const approximateIndex = Math.max(0, Math.floor((now - timer.firstStart) / repeatApproxMs));
      const overlapLookback = Math.max(2, Math.ceil(durationMs / repeatApproxMs) + 2);
      const firstCandidate = Math.max(0, approximateIndex - overlapLookback);
      const lastCandidate = approximateIndex + 2;
      let activeOccurrence = null;

      for (let occurrenceIndex = firstCandidate; occurrenceIndex <= lastCandidate; occurrenceIndex += 1) {
        if (!timer.repeatIndefinitely && occurrenceIndex >= timer.repeatCount) break;

        const dayOffset = occurrenceIndex * timer.repeatEveryDays;
        const occurrenceStart = timerLocalPartsToUtc(addTimerCalendarDays(timer.startParts, dayOffset));
        const occurrenceEnd = timerLocalPartsToUtc(addTimerCalendarDays(timer.endParts, dayOffset));

        if (!Number.isFinite(occurrenceStart) || !Number.isFinite(occurrenceEnd)) continue;
        if (now < occurrenceStart || now >= occurrenceEnd) continue;

        if (!activeOccurrence || occurrenceEnd < activeOccurrence.end) {
          activeOccurrence = {
            timer,
            start: occurrenceStart,
            end: occurrenceEnd
          };
        }
      }

      return activeOccurrence;
    };

    const formatSaleTimerRemaining = (remainingMs) => {
      const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const parts = [
        [days, 'D.'],
        [hours, 'HRS.'],
        [minutes, 'MIN.'],
        [seconds, 'SEC.']
      ];

      return parts.map(([value, unit]) => (
        `<span class="twomatoes-product-sale-timer-part">` +
          `<span class="twomatoes-product-sale-timer-number">${value}</span>` +
          `<span class="twomatoes-product-sale-timer-unit">${unit}</span>` +
        `</span>`
      )).join('');
    };

    const updateSaleTimer = () => {
      if (!saleTimer || !saleTimerBar || !saleTimerText || !saleTimerCountdown || saleTimerConfigs.length === 0) {
        if (saleTimer) {
          saleTimer.classList.add('is-resolved-inactive');
          saleTimer.hidden = true;
        }
        return;
      }

      const now = Date.now();
      const activeOccurrences = saleTimerConfigs
        .map((timer) => getActiveTimerOccurrence(timer, now))
        .filter(Boolean)
        .sort((a, b) => (a.end - b.end) || (a.timer.order - b.timer.order));

      const active = activeOccurrences[0];

      if (!active) {
        saleTimer.classList.add('is-resolved-inactive');
        saleTimer.hidden = true;
        saleTimer.removeAttribute('data-active-timer-id');
        return;
      }

      saleTimer.classList.remove('is-resolved-inactive');
      saleTimer.hidden = false;
      saleTimer.dataset.activeTimerId = active.timer.id;
      saleTimerBar.style.setProperty('--twomatoes-product-sale-timer-background', active.timer.backgroundColor);
      saleTimerBar.style.setProperty('--twomatoes-product-sale-timer-color', active.timer.textColor);
      const timerLabel = String(active.timer.text || '')
        .replace(/^[\s🍂🍁]+|[\s🍂🍁]+$/g, '')
        .trim();

      saleTimerText.textContent = timerLabel;
      saleTimerCountdown.innerHTML = formatSaleTimerRemaining(active.end - now);
    };

    if (saleTimerConfigs.length > 0) {
      updateSaleTimer();
      root.twomatoesSaleTimerInterval = window.setInterval(updateSaleTimer, 1000);
    } else if (saleTimer) {
      saleTimer.classList.add('is-resolved-inactive');
      saleTimer.hidden = true;
    }

    const variantRadios = Array.from(root.querySelectorAll('[data-variant-radio]'));
    const variantIdInput = root.querySelector('[data-product-variant-id]');
    const productFormComponent = root.querySelector('product-form-component');
    const productForm = root.querySelector('form[data-type="add-to-cart-form"]');
    const addToCartButton = root.querySelector('[data-add-to-cart]');
    const addToCartText = root.querySelector('[data-add-to-cart-text]');
    const addToCartDefaultContent = root.querySelector('[data-add-to-cart-default-content]');
    const addToCartLoading = root.querySelector('[data-add-to-cart-loading]');
    const selectedPrice = root.querySelector('[data-selected-price]');
    const selectedComparePrice = root.querySelector('[data-selected-compare-price]');
    const productHeadingPrice = root.querySelector('[data-product-heading-price]');
    const productHeadingComparePrice = root.querySelector('[data-product-heading-compare-price]');
    const productHeadingDiscount = root.querySelector('[data-product-heading-discount]');
    const productPackageDiscountTags = Array.from(root.querySelectorAll('[data-product-package-discount]'));
    const stickyAddToCart = root.querySelector('[data-sticky-add-to-cart]');
    const stickyAddToCartButton = root.querySelector('[data-sticky-add-to-cart-button]');
    const stickyAddToCartText = root.querySelector('[data-sticky-add-to-cart-text]');
    const stickyAddToCartDefaultContent = root.querySelector('[data-sticky-add-to-cart-default-content]');
    const stickyAddToCartLoading = root.querySelector('[data-sticky-add-to-cart-loading]');
    const stickySelectedPrice = root.querySelector('[data-sticky-selected-price]');
    const stickySelectedComparePrice = root.querySelector('[data-sticky-selected-compare-price]');
    const stickyBundlePanel = root.querySelector('[data-sticky-bundle-panel]');
    const stickyBundleToggle = root.querySelector('[data-sticky-bundle-toggle]');
    const stickyBundleClose = root.querySelector('[data-sticky-bundle-close]');
    const stickySelectedBundleTitle = root.querySelector('[data-sticky-selected-bundle-title]');
    const stickyVariantOptions = Array.from(root.querySelectorAll('[data-sticky-variant-option]'));
    let isAddingToCart = false;
    let selectedVariantAvailable = false;
    let isStickyBundlePanelOpen = false;
    let stickyAddToCartReservedHeight = 0;

    const setAddToCartLoading = (loading) => {
      isAddingToCart = loading;

      if (addToCartButton) {
        addToCartButton.disabled = loading || !selectedVariantAvailable;
        addToCartButton.setAttribute('aria-busy', loading ? 'true' : 'false');
        addToCartButton.classList.toggle('is-loading', loading);
      }

      if (stickyAddToCartButton) {
        stickyAddToCartButton.disabled = loading || !selectedVariantAvailable;
        stickyAddToCartButton.setAttribute('aria-busy', loading ? 'true' : 'false');
        stickyAddToCartButton.classList.toggle('is-loading', loading);
      }

      if (addToCartDefaultContent) addToCartDefaultContent.hidden = loading;
      if (addToCartLoading) addToCartLoading.hidden = !loading;
      if (stickyAddToCartDefaultContent) stickyAddToCartDefaultContent.hidden = loading;
      if (stickyAddToCartLoading) stickyAddToCartLoading.hidden = !loading;
    };

    const updateSelectedVariant = (radio, updateUrl = true) => {
      if (!radio) return;

      const available = radio.dataset.available === 'true';
      selectedVariantAvailable = available;
      const price = radio.dataset.price || '';
      const comparePrice = radio.dataset.comparePrice || '';
      const discountPercent = radio.dataset.discountPercent || '';
      const mediaId = radio.dataset.featuredMediaId || '';
      const bundleTitle = radio.dataset.bundleTitle || '';

      if (variantIdInput) variantIdInput.value = radio.value;

      if (addToCartButton && !isAddingToCart) {
        addToCartButton.disabled = !available;
        if (addToCartText) addToCartText.textContent = available ? addToCartButton.dataset.addToCartLabel : addToCartButton.dataset.soldOutLabel;
      }

      if (stickyAddToCartButton && !isAddingToCart) {
        stickyAddToCartButton.disabled = !available;
        if (stickyAddToCartText) stickyAddToCartText.textContent = available ? stickyAddToCartButton.dataset.addToCartLabel : stickyAddToCartButton.dataset.soldOutLabel;
      }

      if (selectedPrice) selectedPrice.textContent = price;
      if (stickySelectedPrice) stickySelectedPrice.textContent = price;
      if (stickySelectedBundleTitle) stickySelectedBundleTitle.textContent = bundleTitle;
      if (productHeadingPrice) productHeadingPrice.textContent = price;

      stickyVariantOptions.forEach((option) => {
        const isSelected = option.dataset.variantId === radio.value;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      if (selectedComparePrice) {
        selectedComparePrice.textContent = comparePrice;
        selectedComparePrice.hidden = comparePrice === '';
      }

      if (stickySelectedComparePrice) {
        stickySelectedComparePrice.textContent = comparePrice;
        stickySelectedComparePrice.hidden = comparePrice === '';
      }

      if (productHeadingComparePrice) {
        productHeadingComparePrice.textContent = comparePrice;
        productHeadingComparePrice.hidden = comparePrice === '';
      }

      if (productHeadingDiscount) {
        productHeadingDiscount.textContent = discountPercent ? `SAVE ${discountPercent}%` : '';
        productHeadingDiscount.hidden = discountPercent === '';
      }

      productPackageDiscountTags.forEach((tag) => {
        const hasDiscount = discountPercent !== '';
        tag.textContent = hasDiscount ? `-${discountPercent}% OFF` : '';
        tag.hidden = !hasDiscount;

        const packageItem = tag.closest('.twomatoes-package-item');
        const customTag = packageItem?.querySelector('[data-product-package-custom-tag]');
        if (customTag) customTag.hidden = hasDiscount;
      });

      showMedia(mediaId);

      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url.toString());
      }
    };

    const syncStickyFooterClearance = () => {
      if (!stickyAddToCart) return;

      if (!isStickyBundlePanelOpen) {
        stickyAddToCartReservedHeight = Math.ceil(stickyAddToCart.getBoundingClientRect().height);
      }

      const visible = stickyAddToCart.classList.contains('is-visible') && stickyAddToCartReservedHeight > 0;
      document.documentElement.style.setProperty('--twomatoes-sticky-atc-height', visible ? `${stickyAddToCartReservedHeight}px` : '0px');
      document.body.classList.toggle('twomatoes-sticky-atc-visible', visible);
    };

    const setStickyBundlePanelOpen = (open, focusTarget = '') => {
      if (!stickyAddToCart || !stickyBundlePanel || !stickyBundleToggle) return;

      isStickyBundlePanelOpen = open;
      stickyAddToCart.classList.toggle('is-selector-open', open);
      stickyBundlePanel.setAttribute('aria-hidden', open ? 'false' : 'true');
      stickyBundleToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      stickyBundlePanel.inert = !open;

      window.requestAnimationFrame(() => {
        if (open && focusTarget === 'selected') {
          const selectedOption = stickyVariantOptions.find((option) => option.classList.contains('is-selected'));
          (selectedOption || stickyVariantOptions[0] || stickyBundleClose)?.focus();
        }

        if (!open && focusTarget === 'toggle') stickyBundleToggle.focus();
        if (!open) syncStickyFooterClearance();
      });
    };

    const setStickyAddToCartVisibility = (visible) => {
      if (!stickyAddToCart) return;

      stickyAddToCart.classList.toggle('is-visible', visible);
      stickyAddToCart.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (!visible && isStickyBundlePanelOpen) setStickyBundlePanelOpen(false);
      window.requestAnimationFrame(syncStickyFooterClearance);
    };

    if (stickyAddToCart && addToCartButton) {
      root.twomatoesProductStoryCleanup?.();
    root.twomatoesStickyAddToCartObserver?.disconnect();

      const stickyAddToCartObserver = new IntersectionObserver(
        ([entry]) => setStickyAddToCartVisibility(!(entry.isIntersecting && entry.intersectionRatio > 0)),
        {
          root: null,
          threshold: [0, 0.01]
        }
      );

      root.twomatoesStickyAddToCartObserver = stickyAddToCartObserver;
      stickyAddToCartObserver.observe(addToCartButton);

      window.requestAnimationFrame(() => {
        const buttonRect = addToCartButton.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        const isVisible = buttonRect.bottom > 0 && buttonRect.top < viewportHeight && buttonRect.right > 0 && buttonRect.left < viewportWidth;

        setStickyAddToCartVisibility(!isVisible);
      });
    }

    if (stickyAddToCart && 'ResizeObserver' in window) {
      root.twomatoesStickyAddToCartResizeObserver?.disconnect();

      const stickyAddToCartResizeObserver = new ResizeObserver(() => {
        if (!isStickyBundlePanelOpen) syncStickyFooterClearance();
      });

      root.twomatoesStickyAddToCartResizeObserver = stickyAddToCartResizeObserver;
      stickyAddToCartResizeObserver.observe(stickyAddToCart);
    }

    if (stickyBundlePanel) stickyBundlePanel.inert = true;

    stickyBundleToggle?.addEventListener('click', () => {
      setStickyBundlePanelOpen(!isStickyBundlePanelOpen, isStickyBundlePanelOpen ? '' : 'selected');
    });

    stickyBundleClose?.addEventListener('click', () => {
      setStickyBundlePanelOpen(false, 'toggle');
    });

    stickyVariantOptions.forEach((option) => {
      option.addEventListener('click', () => {
        if (option.disabled) return;

        const matchingRadio = variantRadios.find((radio) => radio.value === option.dataset.variantId);
        if (!matchingRadio || matchingRadio.disabled) return;

        matchingRadio.checked = true;
        matchingRadio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !isStickyBundlePanelOpen) return;

      event.preventDefault();
      setStickyBundlePanelOpen(false, 'toggle');
    });

    stickyAddToCartButton?.addEventListener('click', () => {
      if (!productForm || !addToCartButton || stickyAddToCartButton.disabled) return;

      if (isStickyBundlePanelOpen) setStickyBundlePanelOpen(false);

      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit(addToCartButton);
        return;
      }

      addToCartButton.click();
    });

    productForm?.addEventListener('submit', () => {
      if (!addToCartButton || addToCartButton.disabled || !productForm.checkValidity()) return;
      setAddToCartLoading(true);
    });

    productFormComponent?.addEventListener('shopify:cart:lines-update', (event) => {
      if (event.action !== 'add' || !event.promise) return;

      event.promise
        .then(() => setAddToCartLoading(false))
        .catch(() => setAddToCartLoading(false));
    });

    variantRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) updateSelectedVariant(radio);
      });
    });

    updateSelectedVariant(variantRadios.find((radio) => radio.checked), false);
  };

  const initializeAllProductSections = (scope = document) => {
    scope.querySelectorAll('[data-twomatoes-product-section]').forEach(initializeProductSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllProductSections());
  } else {
    initializeAllProductSections();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllProductSections(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-twomatoes-product-section]');
    if (!root) return;

    root.twomatoesProductStoryCleanup?.();
    root.twomatoesStickyAddToCartObserver?.disconnect();
    root.twomatoesStickyAddToCartResizeObserver?.disconnect();
    if (root.twomatoesSaleTimerInterval) window.clearInterval(root.twomatoesSaleTimerInterval);
    if (root.twomatoesDescriptionResizeHandler) window.removeEventListener('resize', root.twomatoesDescriptionResizeHandler);
    document.body.classList.remove('twomatoes-sticky-atc-visible');
    document.documentElement.style.removeProperty('--twomatoes-sticky-atc-height');
  });
})();
